import { atom } from 'recoil';

export const isNewEquipmentModalOpenAtom = atom<boolean>({
  key: 'isNewEquipmentModalOpenState',
  default: false,
});
